import { compose, isEmpty } from 'ramda'
import { withNamespaces } from '>/i18n'
import { useQuery } from '@apollo/client'
import gql from 'graphql-tag'
import get from 'lodash/get'

import withLayout from '~/hoc/withLayout'

import Footer from '~/components/Footer/FooterGql'
import RegulationItem from '~/components/RegulationItem'
import Modal from '~/components/Modal'
import { commonModals } from '~/components/Modal/modalsList'

const GET_REGULATIONS = gql`
  query documents {
    documents {
      nodes {
        id
        title
        festivalEdition {
          id
        }
      }
    }
  }
`

const Regulations = ({ t }) => {
  const { data } = useQuery(GET_REGULATIONS)
  const regulations = [...get(data, 'documents.nodes', [])].sort((a, b) => {
    return get(a, 'festivalEdition.id', 0) - get(b, 'festivalEdition.id', 0)
  })

  return (
    <>
      <div className='regulations container'>
        <h2 className='regulations__heading'>
          {t('heading')}
        </h2>
        <ul className='regulations__list'>
          {!isEmpty(regulations) && regulations.map(document =>
            <RegulationItem key={document.id} document={document} />
          )}
        </ul>
      </div>
      <Footer />
      <Modal components={commonModals} />
    </>
  )
}

export default compose(
  withLayout({
    namespaces: ['regulations'],
  }),
  withNamespaces('regulations')
)(Regulations)
